import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import api from 'src/axios';

type Variables = {
  sessionId: string;
  sku: number;
};

export const useDeleteProductFromSession = (
  options?: Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'>,
): UseMutationResult<void, Error, Variables> => {
  return useMutation({
    mutationFn: async ({ sessionId, sku }: Variables) => {
      const { data } = await api.delete(
        `/sales-forecasting-sessions/${sessionId}/products/${sku}`,
      );
      return data;
    },
    ...options,
  });
};
